import { Injectable } from '@angular/core';
import { Config, FRUser, OAuth2Tokens, TokenManager, UserManager } from '@forgerock/javascript-sdk';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.generated';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class AuthService {
    private localStorageTokenItemName = `FR-SDK-${environment.forgerock.clientId}`; // automatically used by the sdk to set the token in localstorage after login
    private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
    public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
    public tokenExpiryMs!: number;

    constructor(private router: Router) {
        this.restoreAuthState();
    }

    private restoreAuthState(): void {
        const tokenDataRaw = localStorage.getItem(this.localStorageTokenItemName);
        if (tokenDataRaw) {
            try {
                const tokenData = JSON.parse(tokenDataRaw);
                const { accessToken, tokenExpiry } = tokenData;
                if (accessToken && tokenExpiry && Date.now() < tokenExpiry) {
                    this.tokenExpiryMs = tokenExpiry;
                    this.isAuthenticatedSubject.next(true);
                    return;
                }
            } catch (e) {
                console.error(`Error parsing token data from localStorage:`, e);
            }
        }
        this.isAuthenticatedSubject.next(false);
    }

    public updateAuthStateAfterLogin(): void {
        this.restoreAuthState();
    }

    initializeForgerock(): void {
        Config.set(environment.forgerock);
    }

    login$(): Observable<void | OAuth2Tokens> {
        return from(TokenManager.getTokens({ login: 'redirect' }));
    }

    handleAuthCallback$(code: string, state: string): Observable<void | OAuth2Tokens> {
        return from(TokenManager.getTokens({ query: { code, state } }));
    }

    getUserInfo$(): Observable<any> {
        return from(UserManager.getCurrentUser());
    }

    public logout(): void {
        localStorage.removeItem(this.localStorageTokenItemName);
        FRUser.logout();
        this.isAuthenticatedSubject.next(false);
        this.router.navigate(['/login']);
    }
}